import React, { useState } from 'react'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import { request } from '../../_network/request'
import { clientAccountsURLs } from '../../_network/apiUrls'
import CustomBackdrop from '../_common/CustomBackdrop'

const UserDelete = (props) => {
  const { handleDeleteUserDialogClose, editUser, setFetchUsers } = props
  const theme = useTheme()

  const [isLoading, setIsLoading] = useState(false)

  const deleteButtonStyle = {
    fontWeight: '500',
    color: 'white',
    background: theme.palette.greenSheen,
    fontSize: '18px',
    height: '40px',
    borderRadius: '20px',
    padding: '0px 30px',
    textTransform: 'capitalize',

    '&:hover': {
      background: alpha(theme.palette.greenSheen, 0.8),
    },
  }

  const deleteRequest = async () => {
    setIsLoading(true)

    const url = constants.core_service_domain + '/' + clientAccountsURLs.getUsers + '/' + editUser.id
      
    const request_data = { url, method: 'DELETE' }
    
    const response = await request(request_data)

    setIsLoading(false)
    
    if (response && response.status_code && response.status_code < 400) {
      handleDeleteUserDialogClose()
      setFetchUsers(prev => prev + 1)
    }    
  }

  return (
    <>
      { isLoading && <CustomBackdrop open={isLoading} /> }

      <Box sx={{ marginBottom: '20px' }}>{editUser && defaultTexts.deleteUserText.replace('###USER###', editUser.firstName + ' ' + editUser.lastName)}</Box>

      <Stack
        direction='row'
        justifyContent='flex-end'
      >
        <Button
          variant='contained'
          disableRipple
          disableElevation
          disabled={false}
          onClick={deleteRequest}
          sx={deleteButtonStyle}
        >
          {defaultTexts.delete}
        </Button>
      </Stack>
    </>
  )
}

export default UserDelete